import Shuffle from 'shufflejs';
import 'magnific-popup';

export const SELECTORS = {
    root:           '.js-content-hub',
    elementWrapper: '.js-content-hub-wrapper',
    element:        '.js-content-hub-item',
    elementCard:    '.js-content-hub-item .cards-block',
    video:          '.js-content-hub-item video',
    iframe:         '.js-content-hub-item iframe',
};

export default class CardsLayout {
    constructor(element) {
        this.SELECTORS = SELECTORS;

        /**
         * Cards Block Listing
         * @type {jQuery|HTMLElement}
         */
        this.ELEMENT = element;

        /**
         * Shuffled cards
         * @type {null}
         */
        this.SHUFFLEDCARDS;

        this.initComponents().then(_ => {
            this.registerHooks();
        });

    }

    initComponents() {
        const _this = this;

        return new Promise(resolve => {
            if(_this.SELECTORS.root.length > 0) {
                //_this.setElementHeight();
                _this.initShuffleGrid();

                /*if(_this.SELECTORS.video.length > 0) {
                    _this.videoLightbox();
                }*/
                resolve();
            }
        });
    }

    registerHooks() {}

    /**
     * init elements w/ shuffle grid
     */
    initShuffleGrid() {
        const _this = this;
        let elementWrapper = $(_this.SELECTORS.elementWrapper);

        if(elementWrapper){
            _this.SHUFFLEDCARDS = new Shuffle(elementWrapper, {
                itemSelector: _this.SELECTORS.element,
                group: Shuffle.ALL_ITEMS,
                speed: 300,
                gutterWidth: 23,
                useTransforms: true,
                buffer: 1,
            });
        }
    }

    /**
     * workaround to calculate correct heights in IE11
     */
    setElementHeight() {
        const _this = this;

        $(_this.SELECTORS.element).each((i, item) => {
            let $item = $(item),
                itemHeight = $item.find('.cards-block').outerHeight(),
                itemImageHeight = $item.find('.cards-block__image-wrapper').outerHeight(),
                itemContentHeight = $item.find('.cards-block__content').outerHeight();

            $item.height(itemImageHeight + itemContentHeight + 30);
        });
    }

    /**
     * setup markup for video lightbox
     */
    videoLightbox() {
        const _this = this;

        $(_this.SELECTORS.video).each((i, videoLightbox) => {
            let $videoLightbox = $(videoLightbox);

            $videoLightbox.attr('id', 'content-hub-video-'+ i);
            $videoLightbox.attr('preload', 'auto');

            let currentVideoId = $videoLightbox.attr('id');
            $videoLightbox.wrap("<div class='video-lightbox video-lightbox--no-youtube'><a class='[ js-lightbox-video ]' data-lightbox='lightbox' href='#"+ currentVideoId +"'></a></div>");

            $videoLightbox.parent('.js-lightbox-video').magnificPopup({
                type: 'inline',
                callbacks: {
                    open: function() {
                        $('.mfp-content').append($('.mfp-close'));
                        // Play video on open:
                        $('#'+ currentVideoId)[0].play();
                    },
                    close: function() {
                        // Reset video on close:
                        $('#'+ currentVideoId)[0].load();
                    }
                }
            });
        });

        $(_this.SELECTORS.iframe).each((i, videoLightbox) => {
            let $videoLightbox = $(videoLightbox),
                iframeLightboxSrc = $videoLightbox.attr('data-cmp-src');

            $videoLightbox.wrap("<div class='video-lightbox'><a class='[ js-lightbox-iframe ]' data-lightbox='lightbox' href='"+ iframeLightboxSrc +"'><div class='cmp-overlay iframe-overlay'></a></div>");

            $videoLightbox.parent('.js-lightbox-iframe').magnificPopup({
                type:   'iframe',
                iframe: {
                    // Converts Youtube links to embeded videos in Magnific popup.
                    patterns: {
                        youtube: {
                            index: 'youtube.com/',
                            id:    'v=',
                            src:   '//www.youtube-nocookie.com/embed/%id%?autoplay=1&mute=1&rel=0&showinfo=0&enablejsapi=1',
                        },
                    },
                },
            });
        });

    }

}
